// extracted by mini-css-extract-plugin
module.exports = {"bg_l5":"#8f8f8f","monoStack":"\"Roboto Mono\",monospace","primary":"Scrollbar_primary__1urRo"};